module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTQuMTY2IiBoZWlnaHQ9IjQyNy44NCIgdmlld0JveD0iMCAwIDUxNC4xNjYgNDI3Ljg0Ij4KICA8cGF0aCBpZD0i44OR44K5XzY0ODAiIGRhdGEtbmFtZT0i44OR44K5IDY0ODAiIGQ9Ik0tMjg1Ljg4LDQ1Mi4wODNWMjE5LjExOUwyMjguMjg2LDI0LjI0NFYyNTcuMjA4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg1Ljg4MSAtMjQuMjQ0KSIgZmlsbD0ibGltZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_514.svg
// module id = H27t
// module chunks = 0